import type { CommentScoreProps } from './data';

import {
  Box,
  Icon,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Stack,
  Text,
} from '@/components';
import Angry from '@/svgs/products/angry.svg';
import EmptyCircle from '@/svgs/products/empty-circle.svg';
import Happy from '@/svgs/products/happy.svg';
import Poker from '@/svgs/products/poker.svg';

const CommentScore: CommentScoreProps = ({
  commentScore,
  setCommentScore,
  color,
  status,
}) => {
  const labelStyles = {
    mt: '8',
    fontSize: 'xs',
    minW: '10px',
    textAlign: 'center',
  };
  const sliderCircles = Array.from({ length: 11 });

  const iconByStatus = {
    angry: Angry,
    poker: Poker,
    happy: Happy,
  };

  return (
    <Stack w="full" mt="10" px={{ base: '0', md: '24' }}>
      <Slider
        value={commentScore ? commentScore * 10 : 0}
        onChange={(val) => setCommentScore(val / 10)}
        step={10}
        isReversed
      >
        <SliderTrack h="12px" bg="gray.400">
          <SliderFilledTrack h="10px" bg={color} />
          <Stack direction="row-reverse" justify="space-between" gap="0">
            {sliderCircles.map((_, index) => (
              <Text key={index}>
                {commentScore === null || index > commentScore ? (
                  <EmptyCircle />
                ) : (
                  <Box width={3}></Box>
                )}
              </Text>
            ))}
          </Stack>
        </SliderTrack>
        <SliderThumb
          boxSize={3}
          bg="text"
          position="relative"
          left={
            commentScore
              ? `calc(${commentScore * 10}% - ${commentScore - 5}px) !important`
              : '5px !important'
          }
        >
          {status !== 'unset' && (
            <Icon
              as={iconByStatus[status]}
              position="absolute"
              bottom="20px"
              width={{ base: '31px', md: '42px' }}
              height={{ base: '31px', md: '42px' }}
            />
          )}
        </SliderThumb>
        <Stack direction="row-reverse" justify="space-between" gap="0">
          {Array.from({ length: 11 }, (_, i) => (
            <Text key={i} sx={labelStyles}>
              {i}
            </Text>
          ))}
        </Stack>
      </Slider>
    </Stack>
  );
};

export default CommentScore;
